import React, { useEffect } from "react"
import PropTypes from "prop-types"
import withRouter from "./Common/withRouter"
import Spinners from "components/Shared/Spinners"
import { usePortalTenant } from "context/PortalTenantContext"
import { shouldResolvePortalTenant } from "utils/portalHost"

const NonAuthLayout = props => {
  const { loading } = usePortalTenant()

  useEffect(() => {
    const html = document.documentElement
    const previousTheme = html.getAttribute("data-bs-theme")
    html.setAttribute("data-bs-theme", "light")

    return () => {
      if (previousTheme) {
        html.setAttribute("data-bs-theme", previousTheme)
      } else {
        html.removeAttribute("data-bs-theme")
      }
    }
  }, [])

  if (shouldResolvePortalTenant() && loading) {
    return <Spinners />
  }

  return <React.Fragment>{props.children}</React.Fragment>
}

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
}

export default withRouter(NonAuthLayout)
